import { Component, EventEmitter, Input, Output } from '@angular/core';

import { MatIcon } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { ButtonsCard, LocationCard } from '../../shared/models/components-general/card.model';

@Component({
  selector: 'app-card-locations',
  imports: [MatIcon, MatButtonModule, CommonModule],
  templateUrl: './card-locations.html',
  styleUrl: './card-locations.css',
})
export class CardLocations {
  @Output() public eventLocation: EventEmitter<{ button: ButtonsCard; id: number }> =
    new EventEmitter<{ button: ButtonsCard; id: number }>();
  @Output() public eventDetail: EventEmitter<number> = new EventEmitter<number>();
  @Input() public itemLocation: LocationCard | null = null;

  public onEvent(button: ButtonsCard) {
    if (this.itemLocation) {
      this.eventLocation.emit({ button, id: this.itemLocation.id });
    }
  }

  public onEventDetail() {
    if (this.itemLocation) {
      this.eventDetail.emit(this.itemLocation.id);
    }
  }
}
